import { useMemo } from "react";
import { Link } from "react-router-dom";
import { WrenchScrewdriverIcon } from "@heroicons/react/24/outline";
import ToolboxSectionToolsAccordion from "../../../../components/ToolboxSectionToolsAccordion";
import {
  SectionEmptyState,
  SectionHeader,
} from "../../../../componentLibrary/SectionPanel";
import type { ModuleI } from "../../../../types";
import { getToolboxToolSectionGroupsForTopic } from "../../../../utils/toolboxTools";

const sectionCard =
  "rounded-xl border-2 border-dashed border-gray-300 bg-white p-4";

export default function ToolsSection({ topic }: { topic: ModuleI }) {
  const toolSections = useMemo(
    () => getToolboxToolSectionGroupsForTopic(topic),
    [topic],
  );

  const toolsHref = topic._id
    ? `/admin/toolboxes/${topic._id}/tools`
    : "/admin/toolboxes";

  if (toolSections.length === 0) {
    return (
      <Link
        to={toolsHref}
        className={`block ${sectionCard} hover:border-electrum-300 hover:bg-electrum-50 transition-colors group`}
      >
        <SectionHeader
          icon={
            <WrenchScrewdriverIcon className="h-5 w-5 shrink-0 text-electrum-300" />
          }
          title="My Tools"
        />
        <SectionEmptyState>
          <p className="py-2 text-sm text-gray-400 transition-colors group-hover:text-electrum-300">
            No pages marked as tools — click to manage tools
          </p>
        </SectionEmptyState>
      </Link>
    );
  }

  return (
    <div className={sectionCard}>
      <SectionHeader
        icon={
          <WrenchScrewdriverIcon className="h-5 w-5 shrink-0 text-electrum-300" />
        }
        title="My Tools"
        action="Manage Tools"
        actionTo={toolsHref}
      />
      <div className="flex flex-col gap-2 py-2">
        {toolSections.map((section) => (
          <ToolboxSectionToolsAccordion
            key={section.sectionId}
            section={section}
          />
        ))}
      </div>
    </div>
  );
}
